<template>
  <BaseTableView :head="tableHead" list-view="mdAndUp">
    <WorkClientOfficesTableItem v-for="item in items" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import WorkClientOfficesTableItem from 'components/workClient/offices/WorkClientOfficesTableItem'
export default {
  name: 'WorkClientOfficesTable',
  props: ['items'],
  components: { WorkClientOfficesTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-client']['offices']['nazvanie'],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {active: true},
      ]
    },
  },
  methods: {},
  watch: {},
}
</script>
